import { DataFormProps } from './index';

export function verifyIfFormCanSave(
	dataForm: DataFormProps,
	setCanSaveModuleOnBack: React.Dispatch<React.SetStateAction<boolean>>,
	setMessageErrorForm: React.Dispatch<React.SetStateAction<string>>
) {
	if (dataForm.name === '') {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('Preenha o campo "Título"');
		return;
	}

	if (dataForm.reference_id === '') {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('Preenha o campo "SKU"');
		return;
	}

	if (dataForm.schedule_end !== '' && dataForm.schedule_start === '') {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('Se preencheu a data final, preenha a data inicial.');
		return;
	}

	if (new Date(dataForm.schedule_start) > new Date(dataForm.schedule_end)) {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('A data inicial não pode ser depois da data final');
		return;
	}

	if (new Date(dataForm.schedule_end) < new Date(dataForm.schedule_start)) {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('A data final não pode ser antes da data inicial');
		return;
	}

	setCanSaveModuleOnBack(true);
}
